import React, { useState, useEffect, useRef, LegacyRef } from 'react';

//Hook used from here https://stackoverflow.com/a/54570068/5860825

export const useComponentVisible = (initialIsVisible: boolean): { ref: React.RefObject<HTMLImageElement> | LegacyRef<HTMLImageElement>, isComponentVisible: boolean, setIsComponentVisible: React.Dispatch<React.SetStateAction<boolean>> } => {
    const [isComponentVisible, setIsComponentVisible,] = useState(initialIsVisible);
    const ref = useRef<HTMLImageElement>(null);

    const handleHideDropdown = (event: KeyboardEvent) => {
        if (event.key === 'Escape' && isComponentVisible === true) {
            setIsComponentVisible(false);
        }
    };

    const handleClickOutside = (event: Event) => {
        if (ref.current && !ref.current.contains(event.target as Node) && isComponentVisible === true) {
            setIsComponentVisible(false);
        }
    };

    useEffect(() => {
        if (isComponentVisible === true) {
            document.addEventListener('keydown', handleHideDropdown, true);
            document.addEventListener('click', handleClickOutside, true);
        }
        return () => {
            document.removeEventListener('keydown', handleHideDropdown, true);
            document.removeEventListener('click', handleClickOutside, true);
        };
    });

    return { ref, isComponentVisible, setIsComponentVisible };
}